import {
  Box,
  Button,
  Typography,
  Avatar,
  Paper,
  Grid,
  useTheme,
  useMediaQuery,
  Divider,
  Link,
  Container,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { Fragment, useEffect, useState } from "react";
import { OtpMethodDataArr, PasswordMethodDataArr } from "./Data";
import { commonFormSwitch } from "../../Utils/SwitchCases";
import { HandleFormChange, ValidateFormData } from "../../Utils/Common";
import authApi from "Service/Auth.api";
import { useDispatch } from "react-redux";
import { setMyInfo } from "../../Redux/User/Action";
import { FormateMyInfoData } from "./Formatter";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../Redux/Screen/Action";
import { Home } from "@mui/icons-material";
import ControlledForm from "Components/ControlledForm";

const LoginPage = () => {
  const [formData, setFormData] = useState(PasswordMethodDataArr);
  const [loginMethod, setLoginMethod] = useState("password");
  const [otpSent, setOtpSent] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();

  // 2FA States
  const [is2FA, setIs2FA] = useState(false);
  const [maskedPhone, setMaskedPhone] = useState("");
  const [tempUserData, setTempUserData] = useState(null);
  const [otpValue, setOtpValue] = useState("");

  const parseAndStoreRedirectData = () => {
    const redirectParam = searchParams.get("redirect");
    if (!redirectParam) return;
    try {
      const decodedRedirect = decodeURIComponent(redirectParam);
      const queryPart = decodedRedirect.split("?")[1];
      if (queryPart) {
        const params = new URLSearchParams(queryPart);
        const encodedOrder = params.get("data") || params.get("order");
        if (encodedOrder) {
          const decodedData = JSON.parse(decodeURIComponent(encodedOrder));
          localStorage.setItem("selectedData", JSON.stringify(decodedData));
        }
      }
    } catch (error) {
      console.error("Error parsing redirect data:", error);
    }
  };

  useEffect(() => {
    parseAndStoreRedirectData();
  }, [searchParams]);

  const finalizeLogin = (data) => {
    const myInfoData = FormateMyInfoData(data);
    dispatch(setMyInfo(myInfoData));
    localStorage.setItem("token", data?.token);
    localStorage.setItem("x-nlp-userid", myInfoData?.id);
    dispatch(stopLoading());
    redirectAfterLogin();
  };

  const redirectAfterLogin = () => {
    const redirectParam = searchParams.get("redirect");
    let redirectUrl = `/${RouteUrls.dashboard}`;
    const storedData = localStorage.getItem("selectedData");
    try {
      if (storedData) {
        const decodedData = JSON.parse(storedData);
        if (decodedData.isSubscription === true && decodedData.redirectUrl) {
          localStorage.removeItem("selectedData");
          window.location.href = decodedData.redirectUrl;
          return;
        }
      }
      if (redirectParam) redirectUrl = decodeURIComponent(redirectParam);
      localStorage.removeItem("selectedData");
      navigate(redirectUrl, { replace: true });
    } catch (error) {
      localStorage.removeItem("selectedData");
      navigate(`/${RouteUrls.dashboard}`, { replace: true });
    }
  };

  const handleLoginMethodChange = (method) => {
    setLoginMethod(method);
    setFormData(
      method === "otp"
        ? JSON.parse(JSON.stringify(OtpMethodDataArr))
        : JSON.parse(JSON.stringify(PasswordMethodDataArr))
    );
  };

  const handlePasswordToggle = (fieldId) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  const handleSendOTP = async () => {
    const res = await authApi.mobileSendOtp({
      mobileNumber: formData?.[0]?.value,
      requestType: "login",
    });
    if (res?.success) {
      setOtpSent(true);
      setFormData((prev) =>
        prev.map((el) => (el.id === "otp" ? { ...el, readOnly: false } : el))
      );
    }
  };

  const handleVerifyOtp = async () => {
    dispatch(startLoading({ loading: true, loadtext: "Verifying OTP..." }));
    const mobileNumber = is2FA ? tempUserData?.phone : formData?.[0]?.value;
    const otpValueToVerify = is2FA ? otpValue : formData?.[1]?.value;

    const res = await authApi.verifyOtp({
      mobileNumber: mobileNumber,
      email: null,
      otp: otpValueToVerify,
    });
    if (res?.success) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Otp Verified Successfully",
          alertVariant: "success",
          openAlert: true,
        })
      );
      finalizeLogin(res.data);
    } else {
      dispatch(stopLoading());
    }
  };

  const handlepasswordVerifiction = async () => {
    const verification = ValidateFormData(formData);
    setFormData(verification.formData);
    if (!verification.errorCheck) {
      dispatch(startLoading({ loading: true, loadtext: "Signing In..." }));
      const res = await authApi.signIn({
        username: formData[0].value,
        password: formData[1].value,
      });

      if (res?.success) {
        const myInfoData = FormateMyInfoData(res?.data);
        const role = myInfoData?.userType?.toUpperCase();

        if (role === "CORPORATEUSER" || role === "PROFESSIONAL") {
          const otpRes = await authApi.mobileSendOtp({
            mobileNumber: res?.data?.phone,
            requestType: "login",
          });

          if (otpRes?.success) {
            dispatch(stopLoading());
            setTempUserData(res.data);
            const phone = res?.data?.phone || "";
            setMaskedPhone(`XXXXXX${phone.slice(-4)}`);
            setIs2FA(true);
            setFormData(JSON.parse(JSON.stringify(OtpMethodDataArr)));
            setOtpSent(true);
          }
        } else {
          finalizeLogin(res.data);
        }
      } else {
        dispatch(stopLoading());
      }
    }
  };

  const handleSignIn = async () => {
    if (loading) return;

    setLoading(true);
    try {
      console.log(loginMethod);

      if (loginMethod === "otp") {
        if (!otpSent) {
          await handleSendOTP();
        } else {
          await handleVerifyOtp();
        }
      } else {
        await handlepasswordVerifiction();
      }
    } catch (error) {
      console.error("Sign in error:", error);
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Sign in failed. Please try again.",
          alertVariant: "error",
          openAlert: true,
        })
      )
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f4f7f9 0%, #e9eef2 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      {/* Logo positioned absolutely on top for clean center flow */}
      <Box
        sx={{
          mb: 4,
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
          alt="Logo"
          sx={{
            width: { xs: "180px", md: "180px" },
            cursor: "pointer",
            transition: "0.3s",
            "&:hover": { transform: "scale(1.02)" },
          }}
          onClick={() => (window.location.href = "/home.html")}
        />
      </Box>

      <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center' }}>
        <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 6 },
            width: "100%",
            maxWidth: 480,
            borderRadius: 4,
            textAlign: "center",
            boxShadow: "0px 20px 40px rgba(0,0,0,0.05)",
            border: "1px solid rgba(255,255,255,0.8)",
          }}
        >
          <Avatar
            sx={{
              mx: "auto",
              mb: 2,
              bgcolor: "primary.main",
              width: 64,
              height: 64,
              boxShadow: "0 4px 10px rgba(162, 72, 87, 0.2)",
            }}
          >
            
            
            <LockOutlinedIcon fontSize="large" />
          </Avatar>

          <Typography variant="h4" fontWeight="700" color="text.primary" gutterBottom>
            {is2FA ? "Verify Account" : "Sign In"}
          </Typography>
          <Typography variant="body2" color="text.primary" sx={{ mb: 4 }}>
            {is2FA 
              ? "For your security, please verify your identity" 
              : ""}
          </Typography>

          <Box component="form" noValidate sx={{ width: "100%" }}>
            {is2FA ? (
              /* 2FA VIEW */
              <Fragment>
                <Box sx={{ mb: 3, p: 2, bgcolor: "rgba(162, 72, 87, 0.04)", borderRadius: 2, border: '1px dashed #a24857' }}>
                  <Typography variant="body2" color="primary.main">
                    Verification code sent to: <strong>{maskedPhone}</strong>
                  </Typography>
                </Box>
                <ControlledForm.Input
                  id="contactOtp"
                  label="Enter 4-Digit OTP"
                  maxLength={4}
                  value={otpValue}
                  type="tel"
                  autoFocus
                  onChange={(value) => {
                    const val = value.toString();
                    if (/^\d*$/.test(val) && val.length <= 4) setOtpValue(val);
                  }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  sx={{ mt: 3, py: 1.8, borderRadius: 2, fontWeight: "bold", fontSize: "1rem" }}
                  onClick={handleVerifyOtp}
                >
                  Confirm & Login
                </Button>
              </Fragment>
            ) : (
              /* STANDARD LOGIN VIEW */
              <Fragment>
                {formData.map((el) => (
                  <Box key={el.id} sx={{ mb: 2.5 }}>
                    {commonFormSwitch({
                      formObj: {
                        ...el,
                        onPasswordToggle: el.hasPasswordToggle ? () => handlePasswordToggle(el.id) : undefined,
                      },
                      onChange: (data) => setFormData(HandleFormChange(data, formData)),
                    })}
                  </Box>
                ))}

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 4, mt: -1 }}>
                  <Link
                    component="button"
                    variant="subtitle2"
                    underline="none"
                    type="button"
                    fontWeight="600"
                    onClick={() => handleLoginMethodChange(loginMethod === "otp" ? "password" : "otp")}
                  >
                    {loginMethod === "otp" ? "Use Password" : "Login with OTP"}
                  </Link>
                  <Link
                    component="button"
                    variant="subtitle2"
                    color="error"
                    underline="hover"
                    type="button"
                    onClick={() => navigate(`/${RouteUrls.forgot}`)}
                  >
                    Forgot Password?
                  </Link>
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  sx={{
                    py: 1.8,
                    borderRadius: 2,
                    fontWeight: "bold",
                    fontSize: "1rem",
                    boxShadow: "0 6px 20px rgba(162, 72, 87, 0.25)",
                    "&:hover": { boxShadow: "0 8px 25px rgba(162, 72, 87, 0.35)" }
                  }}
                  disabled={loading}
                  onClick={handleSignIn}
                >
                  {loginMethod === "otp" ? (otpSent ? "Verify OTP" : "Send OTP") : "Sign In"}
                </Button>
              </Fragment>
            )}

            {!is2FA && (
              <>
                <Divider sx={{ my: 4 }}>
                  <Typography variant="caption" color="text.primary" sx={{ px: 1, letterSpacing: 1, fontWeight: 700 }}>
                    NEW USER REGISTRATION
                  </Typography>
                </Divider>

                <Grid container spacing={1.5} display="flex" justifyContent="center">
                  {[
                    { label: "Individual", url: RouteUrls.register },
                    { label: "Corporate", url: `${RouteUrls.register}/${RouteUrls.corporate}` },
                    { label: "NRI", url: `${RouteUrls.register}/${RouteUrls.NriSignup}` },
                    { label: "Professional", url: `${RouteUrls.register}/${RouteUrls.professional}` },
                  ].map((item) => (
                    <Grid item xs={6} key={item.label}>
                      <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{ 
                          borderRadius: 1.5, 
                          textTransform: "none", 
                          fontSize: '0.8rem',
                          borderColor: 'divider',
                          color: 'text.primary',
                          '&:hover': { borderColor: 'primary.main', color: 'primary.main' }
                        }}
                        onClick={() => navigate(`/${item.url}`)}
                      >
                        {item.label}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}

            <Box sx={{ mt: 5 }}>
              <Button
                variant="text"
                startIcon={<Home />}
                color="inherit"
                onClick={() => (window.location.href = "/home.html")}
                sx={{ textTransform: "none", opacity: 0.6, fontSize: '0.9rem' }}
              >
                Back to Homepage
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default LoginPage;